module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/attestato12.dc9c4828.pdf";